module.exports = __webpack_public_path__ + "static/media/Windows.edaf7c8e.svg";